import { useQueryClient } from '@tanstack/react-query'

import { QueryKeys } from '@/types/misc'

export function useInvalidateQueries() {
  const queryClient = useQueryClient()

  return function invalidateQueries(queryKeys: QueryKeys) {
    const invalidatePromises = queryKeys.map((queryKey) =>
      queryClient.invalidateQueries({ queryKey }),
    )

    return Promise.all(invalidatePromises)
  }
}
